import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../locales/translations';
import AdditionalChargesFormLoader from './parts/Loaders/AdditionalChargesFormLoader';
import AdditionalChargesLoader from './parts/Loaders/AdditionalChargesLoader';
import AdditionalChargesTable from './parts/AdditionalChargesTable';

export default function AdditionalCharges() {
  const { t } = useTranslation(
    TranslationsKeys.CONFIGURATION_ADDITIONAL_CHARGES,
  );

  return (
    <AdditionalChargesFormLoader>
      <>
        <AdditionalChargesLoader type="INICIO">
          <AdditionalChargesTable
            type="INICIO"
            title={t('sections.inicio.title')}
            subtitle={t('sections.inicio.subtitle')}
          />
        </AdditionalChargesLoader>

        <AdditionalChargesLoader type="CONTINUIDAD">
          <AdditionalChargesTable
            type="CONTINUIDAD"
            title={t('sections.continuidad.title')}
            subtitle={t('sections.continuidad.subtitle')}
          />
        </AdditionalChargesLoader>
      </>
    </AdditionalChargesFormLoader>
  );
}
